import React from "react";
import { Dialog } from "@vitalsource/vstui";
import styled, { keyframes } from "styled-components";
import { OffScreenStyles } from "../mixins";
import {
  disableBodyScroll,
  enableBodyScroll
} from "../../../utils/body-scroll";
import { t } from "../../core/translate";

const panelSlideIn = keyframes`
  from {
    transform: translateX(100%)
  }

  to {
    transform: translateX(0);
  }
`;

const PanelDialog = styled(Dialog)`
  *[role="dialog"] {
    top: 0;
    right: 0;
    bottom: 0;
    left: auto;
    transform: none;
    max-height: initial;
    border-radius: 0;
    max-width: 100%;
    padding: 0;
    width: 420px;
    animation: ${panelSlideIn} 0.25s;

    *[role="document"] {
      & > div {
        padding: 0;
        margin: 0;
        max-height: 100vh;
        overflow-y: hidden;
        overflow-x: hidden;
      }
      & > div:first-child > button {
        ${OffScreenStyles};
        ${p => p.removeCloseButton && `display: none;`}
      }
      & > div:last-child {
        ${OffScreenStyles};
      }
    }
  }
  & > *:first-child {
    background-color: rgba(0, 0, 0, 0);
  }
  h2 {
    ${OffScreenStyles};
  }
`;

class Panel extends React.Component {
  componentDidMount() {
    this.updateBodyScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.updateBodyScroll();
    }
  }

  componentWillUnmount() {
    enableBodyScroll();
  }

  updateBodyScroll() {
    if (this.props.open) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }

  render() {
    return (
      <PanelDialog
        {...this.props}
        closeButtonLabel={t("base.close", "Close")}
        rootSelector="#bookshelf"
      />
    );
  }
}

export default Panel;
